<nb-card-header *ngIf="!isWatchingFromApp && !this.isSdui" [ngClass]="iconCustomLayoutClass()" >
  <a (click)="backUrlClick()" style="cursor: pointer;"
     class="header-btn">
     <ng-container *ngIf="displayStyle === 'circular'; else defaultIcon">
       <span class="material-symbols-outlined">chevron_left</span>
     </ng-container>
     <ng-template #defaultIcon>
       <img src="/assets/images/bt-back-new.svg" class="icons-svg-list">
     </ng-template>
  </a>
</nb-card-header>

<nb-card-header *ngIf="!isWatchingFromApp && this.isSdui" [ngClass]="iconCustomLayoutClass()" >
  <a (click)="back()" style="cursor: pointer;"
     class="header-btn">
     <ng-container *ngIf="displayStyle === 'circular'; else defaultIconSdui">
       <span class="material-symbols-outlined">chevron_left</span>
     </ng-container>
     <ng-template #defaultIconSdui>
       <img src="/assets/images/bt-back-new.svg" class="icons-svg-list">
     </ng-template>
  </a>
</nb-card-header>
